import { db } from 'helpers/firebase';
// const serverTimestamp = FieldValue.serverTimestamp

export const getForm = (form_id) => {
  if (!form_id) {
    return Promise.reject('form_id is required');
  }
  const ref = db.doc(`/forms/${form_id}`);
  return ref.get();
}

export const getForms = () => {
  const ref = db.collection('/forms')
    .orderBy('order');
  return ref.get()
    .then(colSnap => colSnap.docs)
}